<template>
  <div class="history px-2" id="hDownload">
    <div class="page-title pt-4 pb-4">
      <v-row>
        <v-col cols="12" md="6">
          <h6 class="font-weight-bold text-h5">
            Asset Command <span class="font-weight-medium"> - History</span>
            <v-icon
              color="rgb(0, 102, 124)"
              class="download-icon"
              @click="exportPDF('hDownload', 'historyDownload')"
              >mdi-download-box</v-icon
            >
          </h6>
        </v-col>
        <v-col md="2"> </v-col>
        <v-col cols="12" md="4" class="text-right">
          <date-range-picker
            ref="picker"
            :opens="dateRange.startDate ? 'left' : 'left'"
            dateLocale="{ firstDay: 1}"
            :minDate="minDate"
            :maxDate="maxDate"
            :singleDatePicker="singleDatePicker"
            :timePicker="timePicker"
            :timePicker24Hour="timePicker24Hour"
            :showDropdowns="showDropdowns"
            :autoApply="autoApply"
            v-model="dateRange"
            :ranges="false"
            @update="updateValues"
          >
            <template v-slot:input="picker" style="min-width: 350px">
              <div class="d-flex align-center">
            <span v-if="picker.startDate">{{picker.rangeText}}</span>
            <span v-else>Select Date Range Here</span>
                <v-icon> mdi-calendar-month </v-icon>
              </div>
            </template>
          </date-range-picker>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col cols="12" md="6">
        {{palletStr}}
      </v-col>
    </v-row>
    <v-skeleton-loader :loading="loading" type="image">
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="assetHistory"
      :items-per-page="items_per_page"
      class="elevation-1 text-center main-table"
      :hide-default-footer="true"
    >
      <template v-slot:[`item.status_date`]="{ item }">
        {{
          (parseFloat(item.status_date) * 1000)
            | formatDateTime(getUserData.user.timezone)
        }}
      </template>
      <template v-slot:[`item.BATTERY_VOLTAGE`]="{ item }">
        {{ item.BATTERY_VOLTAGE ? item.BATTERY_VOLTAGE / 1000 + " v" : "" }}
      </template>
      <template v-slot:[`header.asset_id`]="{ header }">
        {{ header.text }}
        <v-menu
          offset-y
          :close-on-content-click="false"
          v-model="showmenu"
          content-class="elevation-1 bg-white"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon small> mdi-menu </v-icon
              ><span
                class="filterSelected"
                v-if="
                  selectedHistoryAssetID != '' && selectedHistoryAssetID != null
                "
              ></span>
            </v-btn>
          </template>
          <div
            style="background-color: #f5f5f5; width: 200px; height: 110px"
            class="px-3 pt-4 text-search"
          >
            <v-text-field
              label="Asset ID"
              placeholder="Type Here"
              v-model="selectedHistoryAssetID"
              @click:clear="clearAssetId()"
              outlined
              clearable
              dense
            ></v-text-field>
            <v-btn
              depressed
              class="float-right my-2 white--text font-weight-bold"
              small
              color="rgb(0, 102, 124)"
              :disabled="
                selectedHistoryAssetID === '' || selectedHistoryAssetID === null
                  ? true
                  : false
              "
              @click="updateSelectedAssetID()"
            >
              Apply
            </v-btn>
          </div>
        </v-menu>
      </template>
      <template v-slot:[`header.device_id`]="{ header }">
        {{ header.text }}
        <v-menu
          offset-y
          :close-on-content-click="false"
          v-model="showbeacon"
          content-class="elevation-1 bg-white"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon small> mdi-menu </v-icon>
              <span
                class="filterSelected"
                v-if="
                  selectedHistoryDeviceID != '' &&
                  selectedHistoryDeviceID != null
                "
              ></span>
            </v-btn>
          </template>
          <div
            style="background-color: #f5f5f5; width: 200px; height: 110px"
            class="px-3 pt-4 text-search"
          >
            <v-text-field
              label="Beacon ID"
              placeholder="Type Here"
              v-model="selectedHistoryDeviceID"
              @click:clear="clearBeaconId()"
              outlined
              clearable
              dense
            ></v-text-field>
            <v-btn
              depressed
              class="float-right my-2 white--text font-weight-bold"
              small
              color="rgb(0, 102, 124)"
              :disabled="
                selectedHistoryDeviceID === '' ||
                selectedHistoryDeviceID === null
                  ? true
                  : false
              "
              @click="updateSelectedDeviceID()"
            >
              Apply
            </v-btn>
          </div>
        </v-menu>
      </template>
      <template v-slot:[`header.status_date`]="{ header }">
        <span @click="dateFilter()"> {{ header.text }} </span>
      </template>
      <template v-slot:[`header.status`]="{ header }">
        {{ header.text }}
        <v-menu
          offset-y
          :close-on-content-click="false"
          content-class="elevation-1"
          v-model="showCheck"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon small> mdi-menu </v-icon>
              <span
                class="filterSelected"
                v-if="isCheckAll != true && selctedStatus.length != 0"
              ></span>
            </v-btn>
          </template>
          <div
            style="background-color: #f5f5f5; width: 200px"
            class="px-3 py-1 label-font"
          >
            <v-simple-checkbox
              @click="checkAll()"
              v-bind="isCheckAll"
              :value="isCheckAll"
              color="black"
              class="mb-3"
            ></v-simple-checkbox
            ><span class="all-label">Check All</span>
            <v-checkbox
              v-model="selctedStatus"
              v-for="(item, i) in status"
              :label="item"
              :value="item"
              :key="i"
              color="black"
            ></v-checkbox>
            <v-btn
              depressed
              class="
                float-right
                my-2
                white--text
                font-weight-bold
                status-button
              "
              small
              color="rgb(0, 102, 124)"
              :disabled="selctedStatus.length == 0 ? true : false"
              @click="selctedStatusApply()"
            >
              Apply
            </v-btn>
          </div>
        </v-menu>
      </template>
          <template v-slot:[`header.BATTERY_VOLTAGE`] = "{header}">
            {{header.text}}
            <v-menu offset-y :close-on-content-click="false" content-class="elevation-1" v-model="showCheckBatteryVoltage">
              <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon small> mdi-menu </v-icon>
              <span
                class="filterSelected"
                v-if="
                  isBVCheckAll != true && selectedBatteryVoltage.length != 0
                "
              ></span>
            </v-btn>
          </template>
          <div
            style="background-color: #f5f5f5; width: 200px"
            class="px-3 py-1 label-font"
          >
            <v-simple-checkbox
              @click="checkAllBV()"
              v-bind="isBVCheckAll"
              :value="isBVCheckAll"
              color="black"
              class="mb-3"
            ></v-simple-checkbox
            ><span class="all-label">Check All</span>
            <v-checkbox
              v-model="selectedBatteryVoltage"
              v-for="(item, i) in batteryVoltageList"
              :label="item"
              :value="item"
              :key="i"
              color="black"
            ></v-checkbox>
            <v-btn
              depressed
              class="
                float-right
                my-2
                white--text
                font-weight-bold
                status-button
              "
              small
              color="rgb(0, 102, 124)"
              :disabled="selectedBatteryVoltage.length == 0 ? true : false"
              @click="selctedStatusApply()"
            >
              Apply
            </v-btn>
          </div>
        </v-menu>
      </template>
      <template v-slot:[`header.location`]="{ header }">
        {{ header.text }}
        <v-menu
          offset-y
          :close-on-content-click="false"
          v-model="showlocation"
          content-class="elevation-1 bg-white"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon small> mdi-menu </v-icon>
              <span
                class="filterSelected"
                v-if="selectedLocation != 'ALL'"
              ></span>
            </v-btn>
          </template>
          <div
            style="background-color: #f5f5f5; width: 200px"
            class="px-3 pt-4"
          >
            <v-select
              :items="locations"
              width="180px"
              :value="selectedLocation"
              label="Select Location"
              dense
              outlined
              float-right
              :menu-props="{ offsetY: true, contentClass: 'ambt-select' }"
              @change="updateSelectedLocation($event)"
            ></v-select>
          </div>
        </v-menu>
      </template>
      <template v-slot:[`header.asset_type`]="{ header }">
        {{ header.text }}
        <v-menu
          offset-y
          :close-on-content-click="false"
          v-model="showItem"
          content-class="elevation-1 bg-white"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon small> mdi-menu </v-icon>
              <span class="filterSelected" v-if="selectedAsset != 'ALL'"></span>
            </v-btn>
          </template>
          <div
            style="background-color: #f5f5f5; width: 200px"
            class="px-3 pt-4"
          >
            <v-select
              :items="assets"
              width="180px"
              v-model="selectedAsset"
              label="Select Asset Type"
              dense
              outlined
              float-right
              :menu-props="{ offsetY: true, contentClass: 'ambt-select' }"
              @change="hideselectedItems()"
            ></v-select>
          </div>
        </v-menu>
      </template>
    </v-data-table>
    </v-skeleton-loader>
    <v-row class="mx-1">
      <v-col class="d-block mx-0 px-0 mt-5">
        <v-select
          :items="pages"
          :value="items_per_page"
          dense
          outlined
          class="float-left wd-80"
          :menu-props="{ offsetY: true, contentClass: 'ambt-select' }"
          @change="updatePerPageItems($event)"
        ></v-select>
        <v-pagination
          flat
          v-model="destination_page"
          color="rgb(0, 102, 124)"
          :length="
            assetHistory.length > 0
              ? Math.ceil(totalRecords / items_per_page)
              : 1
          "
          :total-visible="5"
          class="float-right"
        ></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="js">
// eslint-disable-next-line
/* eslint-disable */
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Vue from 'vue'
import exportPdf from "@/components/mixins/exportPdf.js"
  export default {
    components: { DateRangePicker },
    mixins: [exportPdf],
    data () {
      var current_offset = Vue.prototype.$moment().utcOffset();
      var off_set = Vue.prototype.$moment().tz('America/New_York').utcOffset();
        var min_set = -(current_offset - off_set);
      const start_date = Vue.prototype.$moment().utcOffset(min_set).subtract(6, "days")._d;
      const end_date = Vue.prototype.$moment().utcOffset(min_set)._d;
      return {
        dateRange: { startDate: start_date, endDate: end_date },
        opens: 'left',
        minDate: null,
        maxDate: null,
        showmenu: false,
        showlocation: false,
        showItem: false,
        showbeacon: false,
        singleDatePicker: 'range',
        timePicker: false,
        timePicker24Hour: false,
        showDropdowns: false,
        autoApply: false,
        destination_page: 1,
        selected_data: [],
        pages: [10, 25, 50, 100],
        palletStr: "Pallet Types: A 30\"x30\", B - 54\"x40\", C - 82.5\"x54\"",
        headers: [
          { text: 'Asset', value: 'asset_id', align: 'center', sortable: false },
          { text: 'Beacon Id', value: 'device_id', align: 'center', sortable: false },
          { text: 'Type', value: 'asset_type', align: 'center', sortable: false },
          { text: 'Location', align: 'center', value: 'location', sortable: false},
          { text: 'Status', value: 'status', align: 'center', sortable: false },
          { text: "Battery Voltage", value: "BATTERY_VOLTAGE", align: 'center', sortable: false },
          { text: 'Date', value: 'status_date', align: 'center', sortable: false }
        ],
        totalRecords: 1,
        status: [
          'TRANSIT', 'LOST', 'DWELL', 'ACTIVE'
        ],
        batteryVoltageList: [ 'Battery Voltage', 'Null'],
        selectedBatteryVoltage: [ 'Battery Voltage', 'Null'],
        batterVoltageValueList: {'Battery Voltage': 'Not Null','Null':'Null'},
        selctedStatus: [ 'TRANSIT', 'LOST', 'DWELL', 'ACTIVE' ],
        selectedAsset: 'ALL',
        menu: false,
        orderBy: "desc",
        isCheckAll: true,
        isBVCheckAll: true,
        showCheck: false,
        showCheckBatteryVoltage: false,
      }
    },
    computed: {
        loading () {
            return this.$store.getters.getLoading
        },
        items_per_page () {
            return this.$store.getters.getItemsPerPage
        },
        assetHistory () {
            return this.$store.getters.getAssetHistory
        },
        getUserData () {
          return this.$store.getters.getUserInfo
        },
        locations () {
            return this.$store.getters.getLocations
        },
        selectedLocation () {
            return this.$store.getters.getSelectedLocation
        },
        assets () {
            return this.$store.getters.getAssets
        },
        selectedHistoryAssetID: {
            get() {
              return this.$store.getters.getSelectedHistoryAssetID
            },
            set(value) {
                this.$store.commit("SET_SELECTED_HISTORY_ASSET_ID", value)
            }            
        },
        selectedHistoryDeviceID: {
            get() {
              return this.$store.getters.getSelectedHistoryDeviceID
            },
            set(value) {
                this.$store.commit("SET_SELECTED_HISTORY_DEVICE_ID", value)
            }            
        }
    },
    watch: {
      destination_page(val) {
          this.getHistory()
      },
      items_per_page (val) {
        if (this.destination_page !== 1) {
            this.destination_page = 1;
        }else{
            this.getHistory()
        }        
      },
      assetHistory (val) {
          if (val[0]) {
            this.totalRecords = val[0].count
          } else {
            this.totalRecords = 0
          }
      },
      selectedLocation (val) {
        if (this.destination_page !== 1) {
            this.destination_page = 1;
        }else{
            this.getHistory()
        }
      },
      selectedAsset () {
        if (this.destination_page !== 1) {
            this.destination_page = 1;
        }else{
            this.getHistory()
        }
      },
      selctedStatus(val) {
        if (val.length == this.status.length) {
          this.isCheckAll = true;
        } else {
          this.isCheckAll = false;
        }
      },
      selectedBatteryVoltage(val) {
        if (val.length == this.batteryVoltageList.length) {
          this.isBVCheckAll = true;
        } else {
          this.isBVCheckAll = false;
        }
      }
    },
    beforeMount () {
      this.getHistory()
    },
    methods: {
        updatePerPageItems (val) {
            this.$store.dispatch('updateItemsPerPage', val);
        },
        updateSelectedLocation (loc) {
            this.$store.dispatch('updateSelectedLocation', loc);
            this.showlocation = false
        },
        hideselectedItems() {
          this.showItem = false
        },
        getHistory () {
            if (this.selctedStatus.length > 0) {
                var statusFilter = "'"+this.selctedStatus.join("','")+"'"
            }else {
                var statusFilter = "ALL"
            }
            if (this.destination_page === 1) {
                var page = 0
            } else {
                var values = this.assetHistory.map(val => val.index);
                var page = Math.max.apply(null, values);
            }
            const assetID = ( this.selectedHistoryAssetID != ''  &&  this.selectedHistoryAssetID != null ) ? this.selectedHistoryAssetID : 'ALL'
            const deviceID = ( this.selectedHistoryDeviceID != '' &&  this.selectedHistoryDeviceID != null ) ? this.selectedHistoryDeviceID : 'ALL'
            const BV = this.selectedBatteryVoltage.length == 2 ? 'ALL' :  this.batterVoltageValueList[this.selectedBatteryVoltage[0]];
            const historyHomeLocation = this.getUserData.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO' ? 'ALL' : this.getUserData.organization.attributes.find(item=> item.name == 'homeLocation').value;
            const historyParams = { widget: 'ASSET_HISTORY', batteryVoltage: BV, assetID: assetID, assetType: this.selectedAsset , Status: statusFilter, Location:this.selectedLocation, pageSize:this.items_per_page, page: this.destination_page, orderBy: this.orderBy, userOrgHomeLocation: historyHomeLocation, deviceID: deviceID }
            if(this.dateRange.startDate) {
                historyParams.startDateUTC = Vue.prototype.$moment(this.dateRange.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")+" UTC"
                historyParams.endDateUTC = Vue.prototype.$moment(this.dateRange.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")+" UTC"
            }
            this.$store.dispatch('getDeviceData', historyParams);
        },
        updateValues (selectedRange) {
            this.getHistory()
        },
        updateSelectedAssetID () {
          if (this.destination_page !== 1) {
              this.destination_page = 1;
          }else{
              this.getHistory()
          }
          this.showmenu = false
        },
        updateSelectedDeviceID () {
          if (this.destination_page !== 1) {
              this.destination_page = 1;
          }else{
              this.getHistory()
          }
          this.showbeacon = false
        },
      dateFilter () {
        if(this.orderBy == "asc") {
          this.orderBy = "desc"
          this.getHistory()
        } else {
          this.orderBy = "asc"
          this.getHistory()
        }
      },
      checkAll() {
        if (!this.isCheckAll) {
          this.selctedStatus = ["TRANSIT", "LOST", "DWELL", "ACTIVE"];
        } else {
          this.selctedStatus = [];
        }
      },
      checkAllBV() {
        if (!this.isBVCheckAll) {
          this.selectedBatteryVoltage = [ 'Battery Voltage', 'Null'];
        } else {
          this.selectedBatteryVoltage = [];
        }
      },
      selctedStatusApply() {
        if (this.destination_page !== 1) {
          this.destination_page = 1;
        } else {
          this.getHistory();
        }
        this.showCheck = false
        this.showCheckBatteryVoltage = false
      },
      clearBeaconId() {
        this.selectedHistoryDeviceID = ''
        this.getHistory()
        this.showbeacon = false
      },
      clearAssetId() {
        this.selectedHistoryAssetID = ''
        this.getHistory()
        this.showmenu = false
      }
    }
  }
</script>
<style lang="scss">
.ambt-select .theme--light.v-list {
  padding: 0;
}
.ambt-select .v-list-item {
  padding: 0 10px;
}
.label-font .v-label {
  font-size: 14px;
}
.label-font .v-input--selection-controls {
  margin-top: 0;
}
.bg-white fieldset {
  background: #fff;
}
.history .reportrange-text {
  background: none !important;
  border: none !important;
  color: #444 !important;
  font-weight: 500 !important;
}
.history .reportrange-text .v-icon.v-icon {
  color: #333 !important;
  font-size: 2rem !important;
  margin-left: 10px !important;
}
.history .daterangepicker .btn-primary,
.history .daterangepicker .btn-success,
.history .daterangepicker td.active,
.history .daterangepicker td.active:hover {
  background: #00667c;
}
.history td.today[data-v-155e681b] {
  color: #000;
  font-weight: bold;
}
.text-search .v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}
.history
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  padding: 0 10px;
}
.all-label {
  position: absolute;
  top: 9px;
  left: 45px;
  color: rgba(0, 0, 0, 0.6);
}
.status-button {
  z-index: 9999999999999;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/History.vue